export const SIGNIN_QUERY_PARAM_NAME = "signin";
export const FROM_QUERY_PARAM_NAME = "from";
export const AUTHENTICATED_QUERY_PARAM_NAME = "authenticated";
export const SIGNIN_AUTHORIZATION_CODE_QUERY_PARAM_NAME = "code";
export const SIGNIN_STATE_QUERY_PARAM_NAME = "state";
export const SIGNIN_UUID_QUERY_PARAM_NAME = "uuid"